module.exports = __webpack_public_path__ + "static/media/edit.6d2db6bb.svg";